import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../../helpers/common'

export const ReportCaterogiesLoadingKeys = {
    getCategories: "GET_ALL_REPORT_CATEGORIES",
}

const initialState = {
    loading: false,
    categories: [],
    loadingKeys: [],
    firstLoadComplete: false,
    error: null,
}

export const getReportCategories = createAsyncThunk(
    'reportCategories/getReportCategories',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axios.get('/api/v1/report-categories');
            return data;
        } catch (error) {
            if ('string' === typeof error.response.data) {
                return rejectWithValue(error.response.data)
            } else {
                return rejectWithValue(error.response.data.errors || error.response.data.error)
            }
        }
    }
)

export const reportCategories = createSlice({
    name: 'reportCategories',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getReportCategories.pending, (state) => {
                state.loading = true;
                state.loadingKeys = [...state.loadingKeys, ReportCaterogiesLoadingKeys.getCategories];
            })
            .addCase(getReportCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.categories = action.payload.items;
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(ReportCaterogiesLoadingKeys.getCategories, state.loadingKeys);
            })
            .addCase(getReportCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
                state.categories = [];
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(ReportCaterogiesLoadingKeys.getCategories, state.loadingKeys);
            })
    }
})
export const {} = reportCategories.actions;
export default reportCategories.reducer 